var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("e-sidebar", {
    attrs: {
      id: "pay_installment_modal",
      show: _vm.showSidebar,
      fetching: _vm.loading,
      title: _vm.title,
      centered: "",
      size: "xl",
      width: "90%",
      "no-close-on-backdrop": "",
      "hide-header-close": "",
      "hide-footer": "",
    },
    on: { hidden: _vm.cleanModalData },
    scopedSlots: _vm._u([
      {
        key: "content",
        fn: function () {
          return [
            _c(
              "b-card-actions",
              {
                attrs: {
                  title: _vm.$t("Dados do pagamento"),
                  "show-loading": _vm.saving,
                  "no-actions": "",
                },
              },
              [
                _c(
                  "FormulateForm",
                  { ref: "modalPayForm", attrs: { name: "modalPayForm" } },
                  [
                    !_vm.isBulkPay && !_vm.isPaymentConfirmation
                      ? _c(
                          "b-row",
                          [
                            _c(
                              "b-col",
                              { attrs: { md: "2" } },
                              [
                                _c("FormulateInput", {
                                  attrs: {
                                    id: "modal_pay_installment-value",
                                    type: "label",
                                    filter: "currency",
                                    label: _vm.$t("Valor da parcela"),
                                  },
                                  model: {
                                    value: _vm.installmentPayForm.value,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.installmentPayForm,
                                        "value",
                                        $$v
                                      )
                                    },
                                    expression: "installmentPayForm.value",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              "b-col",
                              { attrs: { md: "3" } },
                              [
                                _c("FormulateInput", {
                                  attrs: {
                                    id: "modal_pay_installment-discount",
                                    type: "text-number",
                                    currency: "R$",
                                    precision: 2,
                                    label: _vm.$t("Desconto"),
                                  },
                                  on: {
                                    blur: function (value) {
                                      return _vm.onInputDiscount(
                                        value,
                                        _vm.installmentPayForm
                                      )
                                    },
                                  },
                                  model: {
                                    value: _vm.installmentPayForm.discount,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.installmentPayForm,
                                        "discount",
                                        $$v
                                      )
                                    },
                                    expression: "installmentPayForm.discount",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              "b-col",
                              { attrs: { md: "3" } },
                              [
                                _c("FormulateInput", {
                                  attrs: {
                                    id: "modal_pay_installment-interest",
                                    type: "text-number",
                                    currency: "R$",
                                    precision: 2,
                                    label: _vm.$t("Juros"),
                                  },
                                  on: {
                                    blur: function (value) {
                                      return _vm.onInputInterest(
                                        value,
                                        _vm.installmentPayForm
                                      )
                                    },
                                  },
                                  model: {
                                    value: _vm.installmentPayForm.interest,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.installmentPayForm,
                                        "interest",
                                        $$v
                                      )
                                    },
                                    expression: "installmentPayForm.interest",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              "b-col",
                              { attrs: { md: "2" } },
                              [
                                _c("FormulateInput", {
                                  attrs: {
                                    id: "modal_pay_installment-payment_value",
                                    type: "label",
                                    filter: "currency",
                                    label: _vm.$t("Valor a pagar"),
                                  },
                                  model: {
                                    value: _vm.installmentPayForm.paymentValue,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.installmentPayForm,
                                        "paymentValue",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "installmentPayForm.paymentValue",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              "b-col",
                              { attrs: { md: "2" } },
                              [
                                _c("FormulateInput", {
                                  attrs: {
                                    id: "modal_pay_installment-due_date",
                                    type: "label",
                                    filter: "date",
                                    label: _vm.$t("Vencimento"),
                                  },
                                  model: {
                                    value: _vm.installmentPayForm.dueDate,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.installmentPayForm,
                                        "dueDate",
                                        $$v
                                      )
                                    },
                                    expression: "installmentPayForm.dueDate",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                    !_vm.isPaymentConfirmation
                      ? _c(
                          "b-row",
                          [
                            _c(
                              "b-col",
                              [
                                _c("e-checking-account-combo", {
                                  ref: "checkingAccountCombo",
                                  attrs: {
                                    id: "modal_pay_installment-input_checking_account",
                                    type: ["External"],
                                    "store-id": _vm.storeId,
                                    "show-only-headquarters-accounts":
                                      _vm.hasManyStores,
                                    required: "",
                                    "active-options": "",
                                  },
                                  on: {
                                    "single-option": function (checkAccId) {
                                      return (_vm.installmentPayForm.checkingAccountId =
                                        checkAccId)
                                    },
                                    input: _vm.handleCheckingAccountChange,
                                  },
                                  model: {
                                    value:
                                      _vm.installmentPayForm.checkingAccountId,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.installmentPayForm,
                                        "checkingAccountId",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "installmentPayForm.checkingAccountId",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              "b-col",
                              { attrs: { md: "4" } },
                              [
                                _c("FormulateInput", {
                                  ref: "inputPaymentDate",
                                  staticClass: "required",
                                  attrs: {
                                    id: "modal_pay_installment-input_payment_date",
                                    type: "datepicker",
                                    "hour-default": 12,
                                    label: _vm.$t("Data pagamento"),
                                    placeholder: _vm.$t("dd/mm/aaaa"),
                                    validation: "required",
                                  },
                                  model: {
                                    value: _vm.installmentPayForm.paymentDate,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.installmentPayForm,
                                        "paymentDate",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "installmentPayForm.paymentDate",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.isBulkPay &&
                    !_vm.isPaymentConfirmation &&
                    _vm.selectedCheckingAccount &&
                    _vm.selectedCheckingAccount.workspaceId &&
                    !_vm.hasOtherPaymentMethodsThanPix
                      ? _c(
                          "b-row",
                          [
                            _c(
                              "b-col",
                              [
                                _c("FormulateInput", {
                                  attrs: {
                                    type: "switch",
                                    options: { yes: "Sim", no: "Não" },
                                    label: _vm.$t(
                                      "Deseja realizar os pagamentos no Internet Banking?"
                                    ),
                                    "element-class": ["d-flex", "mt-1"],
                                    instruction: _vm.$t(
                                      "Quando selecionado, o sistema irá realizar a integração dos pagamentos no Internet Banking."
                                    ),
                                  },
                                  model: {
                                    value:
                                      _vm.installmentPayForm
                                        .payOnInternetBanking,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.installmentPayForm,
                                        "payOnInternetBanking",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "installmentPayForm.payOnInternetBanking",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                    !_vm.isBulkPay &&
                    !_vm.isPaymentConfirmation &&
                    _vm.selectedCheckingAccount &&
                    _vm.selectedCheckingAccount.workspaceId
                      ? _c(
                          "b-row",
                          [
                            _c(
                              "b-col",
                              [
                                _c("FormulateInput", {
                                  attrs: {
                                    type: "switch",
                                    label: _vm.$t(
                                      "Deseja realizar o pagamento no Internet Banking?"
                                    ),
                                    instruction: _vm.$t(
                                      "Quando selecionado, o sistema irá realizar a integração do pagamento no Internet Banking."
                                    ),
                                  },
                                  model: {
                                    value:
                                      _vm.installmentPayForm
                                        .payOnInternetBanking,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.installmentPayForm,
                                        "payOnInternetBanking",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "installmentPayForm.payOnInternetBanking",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                    !_vm.isBulkPay &&
                    !_vm.isPaymentConfirmation &&
                    _vm.selectedCheckingAccount &&
                    _vm.selectedCheckingAccount.workspaceId &&
                    _vm.installmentPayForm.payOnInternetBanking &&
                    _vm.installmentPayForm.paymentMethod.method ===
                      _vm.paymentTypeEnum.BANK_SLIP
                      ? _c(
                          "b-row",
                          [
                            _c(
                              "b-col",
                              { attrs: { md: "12" } },
                              [
                                _c("FormulateInput", {
                                  staticClass: "required",
                                  attrs: {
                                    type: "radio",
                                    options: _vm.internetBankingPaymentTypes(),
                                    label: _vm.$t("Tipo de Boleto"),
                                    "element-class": ["d-flex", "mt-1"],
                                    name: "internetBankingPaymentType",
                                    validation: "required",
                                  },
                                  on: {
                                    input: _vm.changeInternetBankingPaymentType,
                                  },
                                  model: {
                                    value:
                                      _vm.installmentPayForm
                                        .internetBankingPaymentType,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.installmentPayForm,
                                        "internetBankingPaymentType",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "installmentPayForm.internetBankingPaymentType",
                                  },
                                }),
                              ],
                              1
                            ),
                            _vm.installmentPayForm
                              .internetBankingPaymentType === "BANKSLIP"
                              ? _c(
                                  "b-col",
                                  [
                                    _c(
                                      "b-tabs",
                                      [
                                        _c(
                                          "b-tab",
                                          {
                                            attrs: {
                                              active: "",
                                              title: _vm.$t("DDA"),
                                            },
                                          },
                                          [
                                            _c(
                                              "b-card-actions",
                                              {
                                                staticStyle: {
                                                  border: "solid 1px #eaeaea",
                                                  "border-radius": "5px",
                                                },
                                                attrs: {
                                                  title: _vm.$t(
                                                    "Selecione um boleto DDA para pagamento"
                                                  ),
                                                  "show-loading":
                                                    _vm.ddaLoading,
                                                  "action-refresh": "",
                                                },
                                                on: {
                                                  refresh:
                                                    _vm.handleCheckingAccountSearchChange,
                                                },
                                              },
                                              [
                                                _c(
                                                  "b-row",
                                                  [
                                                    _c(
                                                      "b-col",
                                                      { attrs: { md: "6" } },
                                                      [
                                                        _c(
                                                          "e-checking-account-combo",
                                                          {
                                                            ref: "checkingAccountComboSearch",
                                                            attrs: {
                                                              id: "modal_pay_installment-input_checking_account_search",
                                                              label: _vm.$t(
                                                                "Conta Corrente para consulta de boletos DDA"
                                                              ),
                                                              type: [
                                                                "External",
                                                              ],
                                                              "store-id":
                                                                _vm.storeId,
                                                              required: "",
                                                              "active-options":
                                                                "",
                                                            },
                                                            on: {
                                                              "single-option":
                                                                function (
                                                                  checkAccId
                                                                ) {
                                                                  return (_vm.installmentPayForm.checkingAccountId =
                                                                    checkAccId)
                                                                },
                                                              input:
                                                                _vm.handleCheckingAccountSearchChange,
                                                            },
                                                            model: {
                                                              value:
                                                                _vm.checkingAccountSearchId,
                                                              callback:
                                                                function ($$v) {
                                                                  _vm.checkingAccountSearchId =
                                                                    $$v
                                                                },
                                                              expression:
                                                                "checkingAccountSearchId",
                                                            },
                                                          }
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                  ],
                                                  1
                                                ),
                                                _c(
                                                  "b-row",
                                                  [
                                                    _c(
                                                      "b-col",
                                                      { attrs: { md: "3" } },
                                                      [
                                                        _c("FormulateInput", {
                                                          attrs: {
                                                            type: "datepicker",
                                                            "hour-default": 12,
                                                            label:
                                                              _vm.$t(
                                                                "Data início"
                                                              ),
                                                            placeholder:
                                                              _vm.$t(
                                                                "dd/mm/aaaa"
                                                              ),
                                                            "only-calendar": true,
                                                          },
                                                          on: {
                                                            input:
                                                              _vm.handleCheckingAccountSearchChange,
                                                          },
                                                          model: {
                                                            value:
                                                              _vm.ddaFilter
                                                                .initialDate,
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                _vm.ddaFilter,
                                                                "initialDate",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "ddaFilter.initialDate",
                                                          },
                                                        }),
                                                      ],
                                                      1
                                                    ),
                                                    _c(
                                                      "b-col",
                                                      { attrs: { md: "3" } },
                                                      [
                                                        _c("FormulateInput", {
                                                          attrs: {
                                                            type: "datepicker",
                                                            "hour-default": 12,
                                                            label:
                                                              _vm.$t(
                                                                "Data fim"
                                                              ),
                                                            placeholder:
                                                              _vm.$t(
                                                                "dd/mm/aaaa"
                                                              ),
                                                            "only-calendar": true,
                                                          },
                                                          on: {
                                                            input:
                                                              _vm.handleCheckingAccountSearchChange,
                                                          },
                                                          model: {
                                                            value:
                                                              _vm.ddaFilter
                                                                .finalDate,
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                _vm.ddaFilter,
                                                                "finalDate",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "ddaFilter.finalDate",
                                                          },
                                                        }),
                                                      ],
                                                      1
                                                    ),
                                                    _c(
                                                      "b-col",
                                                      { attrs: { md: "3" } },
                                                      [
                                                        _c("FormulateInput", {
                                                          attrs: {
                                                            type: "text-number",
                                                            currency: "R$",
                                                            precision: 2,
                                                            label:
                                                              _vm.$t(
                                                                "Valor inicial"
                                                              ),
                                                          },
                                                          on: {
                                                            blur: _vm.handleCheckingAccountSearchChange,
                                                          },
                                                          model: {
                                                            value:
                                                              _vm.ddaFilter
                                                                .initialValue,
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                _vm.ddaFilter,
                                                                "initialValue",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "ddaFilter.initialValue",
                                                          },
                                                        }),
                                                      ],
                                                      1
                                                    ),
                                                    _c(
                                                      "b-col",
                                                      { attrs: { md: "3" } },
                                                      [
                                                        _c("FormulateInput", {
                                                          attrs: {
                                                            type: "text-number",
                                                            currency: "R$",
                                                            precision: 2,
                                                            label:
                                                              _vm.$t(
                                                                "Valor final"
                                                              ),
                                                          },
                                                          on: {
                                                            blur: _vm.handleCheckingAccountSearchChange,
                                                          },
                                                          model: {
                                                            value:
                                                              _vm.ddaFilter
                                                                .finalValue,
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                _vm.ddaFilter,
                                                                "finalValue",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "ddaFilter.finalValue",
                                                          },
                                                        }),
                                                      ],
                                                      1
                                                    ),
                                                  ],
                                                  1
                                                ),
                                                _vm.ddaFilter.returnAll
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass: "mb-1",
                                                        staticStyle: {
                                                          color: "red",
                                                          "text-align":
                                                            "center",
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              _vm.$t(
                                                                "Não foram encontrados boletos DDA com os filtros selecionados, portanto foram retornados todos os boletos DDA emitidos para a conta selecionada."
                                                              )
                                                            ) +
                                                            " "
                                                        ),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                _c("b-table", {
                                                  ref: "ddalist-table",
                                                  class: {
                                                    bordered: true,
                                                    "mb-1": true,
                                                    "bill-pay-select-row": true,
                                                  },
                                                  attrs: {
                                                    "show-empty": "",
                                                    striped: "",
                                                    responsive: "",
                                                    "tbody-tr-class":
                                                      _vm.rowClass,
                                                    fields: _vm.ddaFields,
                                                    items: _vm.ddaList,
                                                    "empty-text":
                                                      _vm.getEmptyTableMessage(
                                                        _vm.$tc(
                                                          "DDA_BANK_SLIP.NAME"
                                                        ),
                                                        "male"
                                                      ),
                                                  },
                                                  on: {
                                                    "row-clicked":
                                                      _vm.onRowClickToSelectPay,
                                                  },
                                                  scopedSlots: _vm._u(
                                                    [
                                                      {
                                                        key: "cell(bulkPay)",
                                                        fn: function (row) {
                                                          return [
                                                            _c(
                                                              "FormulateInput",
                                                              {
                                                                attrs: {
                                                                  type: "radio",
                                                                  "element-class":
                                                                    [
                                                                      "d-flex",
                                                                      "mt-0",
                                                                    ],
                                                                  name: "dda-select",
                                                                  value:
                                                                    row.item
                                                                      .code,
                                                                },
                                                                model: {
                                                                  value:
                                                                    _vm
                                                                      .installmentPayForm
                                                                      .bankSlipDdaCode,
                                                                  callback:
                                                                    function (
                                                                      $$v
                                                                    ) {
                                                                      _vm.$set(
                                                                        _vm.installmentPayForm,
                                                                        "bankSlipDdaCode",
                                                                        $$v
                                                                      )
                                                                    },
                                                                  expression:
                                                                    "installmentPayForm.bankSlipDdaCode",
                                                                },
                                                              }
                                                            ),
                                                          ]
                                                        },
                                                      },
                                                    ],
                                                    null,
                                                    false,
                                                    1365044075
                                                  ),
                                                }),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "b-tab",
                                          {
                                            attrs: {
                                              title: _vm.$t("Código de barras"),
                                            },
                                          },
                                          [
                                            _c(
                                              "b-card-actions",
                                              {
                                                staticStyle: {
                                                  border: "solid 1px #eaeaea",
                                                  "border-radius": "5px",
                                                },
                                                attrs: {
                                                  title: _vm.$t(
                                                    "Digite o código de barras do Boleto"
                                                  ),
                                                  "show-loading":
                                                    _vm.ddaLoading,
                                                },
                                              },
                                              [
                                                _c("FormulateInput", {
                                                  attrs: { type: "text" },
                                                  model: {
                                                    value:
                                                      _vm.installmentPayForm
                                                        .bankSlipBarcode,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.installmentPayForm,
                                                        "bankSlipBarcode",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "installmentPayForm.bankSlipBarcode",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                )
                              : _vm.installmentPayForm
                                  .internetBankingPaymentType === "TAXES"
                              ? _c(
                                  "b-col",
                                  [
                                    _vm.taxesPaymentDetails
                                      ? [
                                          _c("FormulateInput", {
                                            staticClass: "required",
                                            attrs: {
                                              type: "radio",
                                              options:
                                                _vm.internetBankingTaxesPaymentTypes(),
                                              label: _vm.$t(
                                                "Tipo de Imposto/Taxa"
                                              ),
                                              "element-class": [
                                                "d-flex",
                                                "mt-1",
                                              ],
                                              validation: "required",
                                            },
                                            model: {
                                              value:
                                                _vm.installmentPayForm
                                                  .internetBankingTaxType,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.installmentPayForm,
                                                  "internetBankingTaxType",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "installmentPayForm.internetBankingTaxType",
                                            },
                                          }),
                                          _c(
                                            "b-row",
                                            [
                                              _vm.taxField("city")
                                                ? _c(
                                                    "b-col",
                                                    { attrs: { md: "3" } },
                                                    [
                                                      _c("FormulateInput", {
                                                        class: _vm.taxField(
                                                          "city"
                                                        ).required
                                                          ? "required"
                                                          : "",
                                                        attrs: {
                                                          type: "text",
                                                          label:
                                                            _vm.$t("Cidade"),
                                                          maxlength: "150",
                                                          placeholder:
                                                            _vm.$t("SÃO PAULO"),
                                                          validation:
                                                            _vm.taxField("city")
                                                              .required
                                                              ? "required"
                                                              : "",
                                                        },
                                                        model: {
                                                          value:
                                                            _vm
                                                              .taxesPaymentDetails
                                                              .city,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.taxesPaymentDetails,
                                                              "city",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "taxesPaymentDetails.city",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  )
                                                : _vm._e(),
                                              _vm.taxField("stateAbbreviation")
                                                ? _c(
                                                    "b-col",
                                                    { attrs: { md: "2" } },
                                                    [
                                                      _c(
                                                        "e-address-province-combo",
                                                        {
                                                          attrs: {
                                                            required:
                                                              _vm.taxField(
                                                                "stateAbbreviation"
                                                              ).required,
                                                          },
                                                          model: {
                                                            value:
                                                              _vm
                                                                .taxesPaymentDetails
                                                                .stateAbbreviation,
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                _vm.taxesPaymentDetails,
                                                                "stateAbbreviation",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "taxesPaymentDetails.stateAbbreviation",
                                                          },
                                                        }
                                                      ),
                                                    ],
                                                    1
                                                  )
                                                : _vm._e(),
                                              _vm.taxField("taxPayer")
                                                ? _c(
                                                    "b-col",
                                                    { attrs: { md: "3" } },
                                                    [
                                                      _c("FormulateInput", {
                                                        class: _vm.taxField(
                                                          "taxPayer"
                                                        ).required
                                                          ? "required"
                                                          : "",
                                                        attrs: {
                                                          type: "text",
                                                          maxlength: "150",
                                                          label:
                                                            _vm.$t(
                                                              "Contribuinte"
                                                            ),
                                                          placeholder:
                                                            _vm.$t(
                                                              "JOÃO DA SILVA"
                                                            ),
                                                          validation:
                                                            _vm.taxField(
                                                              "taxPayer"
                                                            ).required
                                                              ? "required"
                                                              : "",
                                                        },
                                                        model: {
                                                          value:
                                                            _vm
                                                              .taxesPaymentDetails
                                                              .taxPayer,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.taxesPaymentDetails,
                                                              "taxPayer",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "taxesPaymentDetails.taxPayer",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  )
                                                : _vm._e(),
                                              _vm.taxField("revenueCode")
                                                ? _c(
                                                    "b-col",
                                                    { attrs: { md: "3" } },
                                                    [
                                                      _c("FormulateInput", {
                                                        class: _vm.taxField(
                                                          "revenueCode"
                                                        ).required
                                                          ? "required"
                                                          : "",
                                                        attrs: {
                                                          type: "number",
                                                          maxlength: "15",
                                                          label:
                                                            _vm.$t(
                                                              "Código da Receita"
                                                            ),
                                                          placeholder:
                                                            _vm.$t("1234"),
                                                          validation:
                                                            _vm.taxField(
                                                              "revenueCode"
                                                            ).required
                                                              ? "required"
                                                              : "",
                                                        },
                                                        model: {
                                                          value:
                                                            _vm
                                                              .taxesPaymentDetails
                                                              .revenueCode,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.taxesPaymentDetails,
                                                              "revenueCode",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "taxesPaymentDetails.revenueCode",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  )
                                                : _vm._e(),
                                              _vm.taxField("referenceNumber")
                                                ? _c(
                                                    "b-col",
                                                    { attrs: { md: "3" } },
                                                    [
                                                      _c("FormulateInput", {
                                                        class: _vm.taxField(
                                                          "referenceNumber"
                                                        ).required
                                                          ? "required"
                                                          : "",
                                                        attrs: {
                                                          type: "number",
                                                          maxlength: "15",
                                                          label: _vm.$t(
                                                            "Número de Referência"
                                                          ),
                                                          placeholder:
                                                            _vm.$t(
                                                              "273981240192888"
                                                            ),
                                                          validation:
                                                            _vm.taxField(
                                                              "referenceNumber"
                                                            ).required
                                                              ? "required"
                                                              : "",
                                                        },
                                                        model: {
                                                          value:
                                                            _vm
                                                              .taxesPaymentDetails
                                                              .referenceNumber,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.taxesPaymentDetails,
                                                              "referenceNumber",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "taxesPaymentDetails.referenceNumber",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  )
                                                : _vm._e(),
                                              _vm.taxField("companyName")
                                                ? _c(
                                                    "b-col",
                                                    { attrs: { md: "3" } },
                                                    [
                                                      _c("FormulateInput", {
                                                        class: _vm.taxField(
                                                          "companyName"
                                                        ).required
                                                          ? "required"
                                                          : "",
                                                        attrs: {
                                                          type: "number",
                                                          maxlength: "15",
                                                          label: _vm.$t(
                                                            "Nome da Empresa / Telefone"
                                                          ),
                                                          placeholder: _vm.$t(
                                                            "Tecnologia e Cia - (11)5578-3821"
                                                          ),
                                                          validation:
                                                            _vm.taxField(
                                                              "companyName"
                                                            ).required
                                                              ? "required"
                                                              : "",
                                                        },
                                                        model: {
                                                          value:
                                                            _vm
                                                              .taxesPaymentDetails
                                                              .companyName,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.taxesPaymentDetails,
                                                              "companyName",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "taxesPaymentDetails.companyName",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  )
                                                : _vm._e(),
                                              _vm.taxField("paymentCode")
                                                ? _c(
                                                    "b-col",
                                                    { attrs: { md: "3" } },
                                                    [
                                                      _c("FormulateInput", {
                                                        class: _vm.taxField(
                                                          "paymentCode"
                                                        ).required
                                                          ? "required"
                                                          : "",
                                                        attrs: {
                                                          type: "number",
                                                          maxlength: "15",
                                                          label: _vm.$t(
                                                            "Código de Pagamento"
                                                          ),
                                                          placeholder:
                                                            _vm.$t("5534"),
                                                          validation:
                                                            _vm.taxField(
                                                              "paymentCode"
                                                            ).required
                                                              ? "required"
                                                              : "",
                                                        },
                                                        model: {
                                                          value:
                                                            _vm
                                                              .taxesPaymentDetails
                                                              .paymentCode,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.taxesPaymentDetails,
                                                              "paymentCode",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "taxesPaymentDetails.paymentCode",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  )
                                                : _vm._e(),
                                              _vm.taxField("competency")
                                                ? _c(
                                                    "b-col",
                                                    { attrs: { md: "3" } },
                                                    [
                                                      _c("FormulateInput", {
                                                        directives: [
                                                          {
                                                            name: "mask",
                                                            rawName: "v-mask",
                                                            value: ["####-##"],
                                                            expression:
                                                              "['####-##']",
                                                          },
                                                        ],
                                                        class: _vm.taxField(
                                                          "competency"
                                                        ).required
                                                          ? "required"
                                                          : "",
                                                        attrs: {
                                                          label:
                                                            _vm.$t(
                                                              "Competência"
                                                            ),
                                                          placeholder:
                                                            _vm.$t("2025-01"),
                                                          validation:
                                                            _vm.taxField(
                                                              "competency"
                                                            ).required
                                                              ? "required"
                                                              : "",
                                                        },
                                                        model: {
                                                          value:
                                                            _vm
                                                              .taxesPaymentDetails
                                                              .competency,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.taxesPaymentDetails,
                                                              "competency",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "taxesPaymentDetails.competency",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  )
                                                : _vm._e(),
                                              _vm.taxField("gPSId")
                                                ? _c(
                                                    "b-col",
                                                    { attrs: { md: "3" } },
                                                    [
                                                      _c("FormulateInput", {
                                                        class: _vm.taxField(
                                                          "gPSId"
                                                        ).required
                                                          ? "required"
                                                          : "",
                                                        attrs: {
                                                          type: "number",
                                                          maxlength: "20",
                                                          label:
                                                            _vm.$t(
                                                              "Identificador"
                                                            ),
                                                          placeholder:
                                                            _vm.$t(
                                                              "544133928899000"
                                                            ),
                                                          validation:
                                                            _vm.taxField(
                                                              "gPSId"
                                                            ).required
                                                              ? "required"
                                                              : "",
                                                        },
                                                        model: {
                                                          value:
                                                            _vm
                                                              .taxesPaymentDetails
                                                              .gPSId,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.taxesPaymentDetails,
                                                              "gPSId",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "taxesPaymentDetails.gPSId",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  )
                                                : _vm._e(),
                                              _vm.taxField("assessmentDate")
                                                ? _c(
                                                    "b-col",
                                                    { attrs: { md: "3" } },
                                                    [
                                                      _c("FormulateInput", {
                                                        ref: "inputPaymentDate",
                                                        class: _vm.taxField(
                                                          "assessmentDate"
                                                        ).required
                                                          ? "required"
                                                          : "",
                                                        attrs: {
                                                          type: "datepicker",
                                                          "hour-default": 12,
                                                          label:
                                                            _vm.$t(
                                                              "Data de Apuração"
                                                            ),
                                                          placeholder:
                                                            _vm.$t(
                                                              "dd/mm/aaaa"
                                                            ),
                                                          validation:
                                                            _vm.taxField(
                                                              "assessmentDate"
                                                            ).required
                                                              ? "required"
                                                              : "",
                                                        },
                                                        model: {
                                                          value:
                                                            _vm
                                                              .taxesPaymentDetails
                                                              .assessmentDate,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.taxesPaymentDetails,
                                                              "assessmentDate",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "taxesPaymentDetails.assessmentDate",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  )
                                                : _vm._e(),
                                              _vm.taxField("stateRegistration")
                                                ? _c(
                                                    "b-col",
                                                    { attrs: { md: "3" } },
                                                    [
                                                      _c("FormulateInput", {
                                                        class: _vm.taxField(
                                                          "stateRegistration"
                                                        ).required
                                                          ? "required"
                                                          : "",
                                                        attrs: {
                                                          type: "number",
                                                          maxlength: "15",
                                                          label:
                                                            _vm.$t(
                                                              "Inscrição Estadual"
                                                            ),
                                                          placeholder:
                                                            _vm.$t(
                                                              "183659182736"
                                                            ),
                                                          validation:
                                                            _vm.taxField(
                                                              "stateRegistration"
                                                            ).required
                                                              ? "required"
                                                              : "",
                                                        },
                                                        model: {
                                                          value:
                                                            _vm
                                                              .taxesPaymentDetails
                                                              .stateRegistration,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.taxesPaymentDetails,
                                                              "stateRegistration",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "taxesPaymentDetails.stateRegistration",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  )
                                                : _vm._e(),
                                              _vm.taxField("returnNumber")
                                                ? _c(
                                                    "b-col",
                                                    { attrs: { md: "4" } },
                                                    [
                                                      _c("FormulateInput", {
                                                        class: _vm.taxField(
                                                          "returnNumber"
                                                        ).required
                                                          ? "required"
                                                          : "",
                                                        attrs: {
                                                          type: "number",
                                                          maxlength: "15",
                                                          label:
                                                            _vm.$t(
                                                              "N° da Declaração"
                                                            ),
                                                          placeholder:
                                                            _vm.$t(
                                                              "183659182736"
                                                            ),
                                                          validation:
                                                            _vm.taxField(
                                                              "returnNumber"
                                                            ).required
                                                              ? "required"
                                                              : "",
                                                        },
                                                        model: {
                                                          value:
                                                            _vm
                                                              .taxesPaymentDetails
                                                              .returnNumber,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.taxesPaymentDetails,
                                                              "returnNumber",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "taxesPaymentDetails.returnNumber",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  )
                                                : _vm._e(),
                                              _vm.taxField("document")
                                                ? _c(
                                                    "b-col",
                                                    { attrs: { md: "4" } },
                                                    [
                                                      _c("FormulateInput", {
                                                        class: _vm.taxField(
                                                          "document"
                                                        ).required
                                                          ? "required"
                                                          : "",
                                                        attrs: {
                                                          mask: [
                                                            "###.###.###-##",
                                                            "XX.XXX.XXX/XXXX-##",
                                                          ],
                                                          name: "document",
                                                          type: "text-mask",
                                                          label:
                                                            _vm.$t(
                                                              "CPF ou CNPJ"
                                                            ),
                                                          placeholder:
                                                            _vm.$t(
                                                              "73928427380"
                                                            ),
                                                          validation:
                                                            _vm.taxField(
                                                              "document"
                                                            ).required
                                                              ? "required"
                                                              : "",
                                                        },
                                                        model: {
                                                          value:
                                                            _vm
                                                              .taxesPaymentDetails
                                                              .document,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.taxesPaymentDetails,
                                                              "document",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "taxesPaymentDetails.document",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  )
                                                : _vm._e(),
                                              _vm.taxField("tagNumber")
                                                ? _c(
                                                    "b-col",
                                                    { attrs: { md: "4" } },
                                                    [
                                                      _c("FormulateInput", {
                                                        class: _vm.taxField(
                                                          "tagNumber"
                                                        ).required
                                                          ? "required"
                                                          : "",
                                                        attrs: {
                                                          type: "number",
                                                          maxlength: "15",
                                                          label: _vm.$t(
                                                            "Inscrição na Divida Ativa ou Número da etiqueta"
                                                          ),
                                                          placeholder:
                                                            _vm.$t(
                                                              "8374618273764"
                                                            ),
                                                          validation:
                                                            _vm.taxField(
                                                              "tagNumber"
                                                            ).required
                                                              ? "required"
                                                              : "",
                                                        },
                                                        model: {
                                                          value:
                                                            _vm
                                                              .taxesPaymentDetails
                                                              .tagNumber,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.taxesPaymentDetails,
                                                              "tagNumber",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "taxesPaymentDetails.tagNumber",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  )
                                                : _vm._e(),
                                              _vm.taxField("reference")
                                                ? _c(
                                                    "b-col",
                                                    { attrs: { md: "4" } },
                                                    [
                                                      _c("FormulateInput", {
                                                        directives: [
                                                          {
                                                            name: "mask",
                                                            rawName: "v-mask",
                                                            value: ["##-####"],
                                                            expression:
                                                              "['##-####']",
                                                          },
                                                        ],
                                                        class: _vm.taxField(
                                                          "reference"
                                                        ).required
                                                          ? "required"
                                                          : "",
                                                        attrs: {
                                                          label: _vm.$t(
                                                            "Referência (mm-aaaa)"
                                                          ),
                                                          placeholder:
                                                            _vm.$t("01-2025"),
                                                          validation:
                                                            _vm.taxField(
                                                              "reference"
                                                            ).required
                                                              ? "required"
                                                              : "",
                                                        },
                                                        model: {
                                                          value:
                                                            _vm
                                                              .taxesPaymentDetails
                                                              .reference,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.taxesPaymentDetails,
                                                              "reference",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "taxesPaymentDetails.reference",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  )
                                                : _vm._e(),
                                              _vm.taxField("installment")
                                                ? _c(
                                                    "b-col",
                                                    { attrs: { md: "4" } },
                                                    [
                                                      _c("FormulateInput", {
                                                        class: _vm.taxField(
                                                          "installment"
                                                        ).required
                                                          ? "required"
                                                          : "",
                                                        attrs: {
                                                          type: "number",
                                                          maxlength: "15",
                                                          label: _vm.$t(
                                                            "N° do AIIM ou Nº DEICMEME ou Nº Parcelamento"
                                                          ),
                                                          placeholder:
                                                            _vm.$t("848293745"),
                                                          validation:
                                                            _vm.taxField(
                                                              "installment"
                                                            ).required
                                                              ? "required"
                                                              : "",
                                                        },
                                                        model: {
                                                          value:
                                                            _vm
                                                              .taxesPaymentDetails
                                                              .installment,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.taxesPaymentDetails,
                                                              "installment",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "taxesPaymentDetails.installment",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  )
                                                : _vm._e(),
                                              _vm.taxField("iNSSValue")
                                                ? _c(
                                                    "b-col",
                                                    { attrs: { md: "3" } },
                                                    [
                                                      _c("FormulateInput", {
                                                        class: _vm.taxField(
                                                          "iNSSValue"
                                                        ).required
                                                          ? "required"
                                                          : "",
                                                        attrs: {
                                                          type: "text-number",
                                                          currency: "R$",
                                                          precision: 2,
                                                          label:
                                                            _vm.$t(
                                                              "Valor do INSS"
                                                            ),
                                                          validation:
                                                            _vm.taxField(
                                                              "iNSSValue"
                                                            ).required
                                                              ? "required"
                                                              : "",
                                                        },
                                                        model: {
                                                          value:
                                                            _vm
                                                              .taxesPaymentDetails
                                                              .iNSSValue,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.taxesPaymentDetails,
                                                              "iNSSValue",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "taxesPaymentDetails.iNSSValue",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  )
                                                : _vm._e(),
                                              _vm.taxField("otherValue")
                                                ? _c(
                                                    "b-col",
                                                    { attrs: { md: "3" } },
                                                    [
                                                      _c("FormulateInput", {
                                                        class: _vm.taxField(
                                                          "otherValue"
                                                        ).required
                                                          ? "required"
                                                          : "",
                                                        attrs: {
                                                          type: "text-number",
                                                          currency: "R$",
                                                          precision: 2,
                                                          label: _vm.$t(
                                                            "Valor Outras Entidades"
                                                          ),
                                                          validation:
                                                            _vm.taxField(
                                                              "otherValue"
                                                            ).required
                                                              ? "required"
                                                              : "",
                                                        },
                                                        model: {
                                                          value:
                                                            _vm
                                                              .taxesPaymentDetails
                                                              .otherValue,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.taxesPaymentDetails,
                                                              "otherValue",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "taxesPaymentDetails.otherValue",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  )
                                                : _vm._e(),
                                              _vm.taxField("revenueValue")
                                                ? _c(
                                                    "b-col",
                                                    { attrs: { md: "3" } },
                                                    [
                                                      _c("FormulateInput", {
                                                        class: _vm.taxField(
                                                          "revenueValue"
                                                        ).required
                                                          ? "required"
                                                          : "",
                                                        attrs: {
                                                          type: "text-number",
                                                          currency: "R$",
                                                          precision: 2,
                                                          label: _vm.$t(
                                                            "Valor da Receita (Nominal ou Corrigida)"
                                                          ),
                                                          validation:
                                                            _vm.taxField(
                                                              "revenueValue"
                                                            ).required
                                                              ? "required"
                                                              : "",
                                                        },
                                                        model: {
                                                          value:
                                                            _vm
                                                              .taxesPaymentDetails
                                                              .revenueValue,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.taxesPaymentDetails,
                                                              "revenueValue",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "taxesPaymentDetails.revenueValue",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  )
                                                : _vm._e(),
                                              _vm.taxField("defaultInterest")
                                                ? _c(
                                                    "b-col",
                                                    { attrs: { md: "3" } },
                                                    [
                                                      _c("FormulateInput", {
                                                        class: _vm.taxField(
                                                          "defaultInterest"
                                                        ).required
                                                          ? "required"
                                                          : "",
                                                        attrs: {
                                                          type: "text-number",
                                                          currency: "R$",
                                                          precision: 2,
                                                          label:
                                                            _vm.$t(
                                                              "Juros de Mora"
                                                            ),
                                                          validation:
                                                            _vm.taxField(
                                                              "defaultInterest"
                                                            ).required
                                                              ? "required"
                                                              : "",
                                                        },
                                                        model: {
                                                          value:
                                                            _vm
                                                              .taxesPaymentDetails
                                                              .defaultInterest,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.taxesPaymentDetails,
                                                              "defaultInterest",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "taxesPaymentDetails.defaultInterest",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  )
                                                : _vm._e(),
                                              _vm.taxField("lateFee")
                                                ? _c(
                                                    "b-col",
                                                    { attrs: { md: "3" } },
                                                    [
                                                      _c("FormulateInput", {
                                                        class: _vm.taxField(
                                                          "lateFee"
                                                        ).required
                                                          ? "required"
                                                          : "",
                                                        attrs: {
                                                          type: "text-number",
                                                          currency: "R$",
                                                          precision: 2,
                                                          label: _vm.$t(
                                                            "Multa de Mora ou Multa por Infração"
                                                          ),
                                                          validation:
                                                            _vm.taxField(
                                                              "lateFee"
                                                            ).required
                                                              ? "required"
                                                              : "",
                                                        },
                                                        model: {
                                                          value:
                                                            _vm
                                                              .taxesPaymentDetails
                                                              .lateFee,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.taxesPaymentDetails,
                                                              "lateFee",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "taxesPaymentDetails.lateFee",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  )
                                                : _vm._e(),
                                              _vm.taxField("financeCharge")
                                                ? _c(
                                                    "b-col",
                                                    { attrs: { md: "3" } },
                                                    [
                                                      _c("FormulateInput", {
                                                        class: _vm.taxField(
                                                          "financeCharge"
                                                        ).required
                                                          ? "required"
                                                          : "",
                                                        attrs: {
                                                          type: "text-number",
                                                          currency: "R$",
                                                          precision: 2,
                                                          label: _vm.$t(
                                                            "Acréscimo Financeiro"
                                                          ),
                                                          validation:
                                                            _vm.taxField(
                                                              "financeCharge"
                                                            ).required
                                                              ? "required"
                                                              : "",
                                                        },
                                                        model: {
                                                          value:
                                                            _vm
                                                              .taxesPaymentDetails
                                                              .financeCharge,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.taxesPaymentDetails,
                                                              "financeCharge",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "taxesPaymentDetails.financeCharge",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  )
                                                : _vm._e(),
                                              _vm.taxField("legalFees")
                                                ? _c(
                                                    "b-col",
                                                    { attrs: { md: "3" } },
                                                    [
                                                      _c("FormulateInput", {
                                                        class: _vm.taxField(
                                                          "legalFees"
                                                        ).required
                                                          ? "required"
                                                          : "",
                                                        attrs: {
                                                          type: "text-number",
                                                          currency: "R$",
                                                          precision: 2,
                                                          label: _vm.$t(
                                                            "Honorários Advocatícios"
                                                          ),
                                                          validation:
                                                            _vm.taxField(
                                                              "legalFees"
                                                            ).required
                                                              ? "required"
                                                              : "",
                                                        },
                                                        model: {
                                                          value:
                                                            _vm
                                                              .taxesPaymentDetails
                                                              .legalFees,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.taxesPaymentDetails,
                                                              "legalFees",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "taxesPaymentDetails.legalFees",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  )
                                                : _vm._e(),
                                              _vm.taxField("address")
                                                ? _c(
                                                    "b-col",
                                                    { attrs: { md: "3" } },
                                                    [
                                                      _c("FormulateInput", {
                                                        class: _vm.taxField(
                                                          "address"
                                                        ).required
                                                          ? "required"
                                                          : "",
                                                        attrs: {
                                                          type: "text",
                                                          maxlength: "150",
                                                          label:
                                                            _vm.$t("Endereço"),
                                                          placeholder:
                                                            _vm.$t(
                                                              "Av Interlagos 3501"
                                                            ),
                                                          validation:
                                                            _vm.taxField(
                                                              "address"
                                                            ).required
                                                              ? "required"
                                                              : "",
                                                        },
                                                        model: {
                                                          value:
                                                            _vm
                                                              .taxesPaymentDetails
                                                              .address,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.taxesPaymentDetails,
                                                              "address",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "taxesPaymentDetails.address",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  )
                                                : _vm._e(),
                                              _vm.taxField("phone")
                                                ? _c(
                                                    "b-col",
                                                    { attrs: { md: "3" } },
                                                    [
                                                      _c("FormulateInput", {
                                                        directives: [
                                                          {
                                                            name: "mask",
                                                            rawName: "v-mask",
                                                            value: [
                                                              "(##)####-####",
                                                              "(##)#####-####",
                                                            ],
                                                            expression:
                                                              "['(##)####-####', '(##)#####-####']",
                                                          },
                                                        ],
                                                        class: _vm.taxField(
                                                          "phone"
                                                        ).required
                                                          ? "required"
                                                          : "",
                                                        attrs: {
                                                          type: "text",
                                                          label:
                                                            _vm.$t("Telefone"),
                                                          placeholder:
                                                            _vm.$t(
                                                              "(99)99999-9999"
                                                            ),
                                                          validation:
                                                            _vm.taxField(
                                                              "phone"
                                                            ).required
                                                              ? "required"
                                                              : "",
                                                        },
                                                        model: {
                                                          value:
                                                            _vm
                                                              .taxesPaymentDetails
                                                              .phone,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.taxesPaymentDetails,
                                                              "phone",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "taxesPaymentDetails.phone",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  )
                                                : _vm._e(),
                                              _vm.taxField("cNAE")
                                                ? _c(
                                                    "b-col",
                                                    { attrs: { md: "2" } },
                                                    [
                                                      _c("FormulateInput", {
                                                        class: _vm.taxField(
                                                          "cNAE"
                                                        ).required
                                                          ? "required"
                                                          : "",
                                                        attrs: {
                                                          type: "text",
                                                          label: _vm.$t("CNAE"),
                                                          placeholder:
                                                            _vm.$t("82736457"),
                                                          maxlength: "8",
                                                          validation:
                                                            _vm.taxField("cNAE")
                                                              .required
                                                              ? "required"
                                                              : "",
                                                        },
                                                        model: {
                                                          value:
                                                            _vm
                                                              .taxesPaymentDetails
                                                              .cNAE,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.taxesPaymentDetails,
                                                              "cNAE",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "taxesPaymentDetails.cNAE",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  )
                                                : _vm._e(),
                                              _vm.taxField("postalCode")
                                                ? _c(
                                                    "b-col",
                                                    { attrs: { md: "2" } },
                                                    [
                                                      _c("FormulateInput", {
                                                        class: _vm.taxField(
                                                          "postalCode"
                                                        ).required
                                                          ? "required"
                                                          : "",
                                                        attrs: {
                                                          type: "text",
                                                          label: _vm.$t("CEP"),
                                                          placeholder:
                                                            _vm.$t("73841282"),
                                                          maxlength: "8",
                                                          validation:
                                                            _vm.taxField(
                                                              "postalCode"
                                                            ).required
                                                              ? "required"
                                                              : "",
                                                        },
                                                        model: {
                                                          value:
                                                            _vm
                                                              .taxesPaymentDetails
                                                              .postalCode,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.taxesPaymentDetails,
                                                              "postalCode",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "taxesPaymentDetails.postalCode",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  )
                                                : _vm._e(),
                                              _vm.taxField("observation")
                                                ? _c(
                                                    "b-col",
                                                    { attrs: { md: "3" } },
                                                    [
                                                      _c("FormulateInput", {
                                                        class: _vm.taxField(
                                                          "observation"
                                                        ).required
                                                          ? "required"
                                                          : "",
                                                        attrs: {
                                                          type: "text",
                                                          maxlength: "200",
                                                          label:
                                                            _vm.$t(
                                                              "Observação"
                                                            ),
                                                          placeholder:
                                                            _vm.$t(
                                                              "Observação"
                                                            ),
                                                          validation:
                                                            _vm.taxField(
                                                              "observation"
                                                            ).required
                                                              ? "required"
                                                              : "",
                                                        },
                                                        model: {
                                                          value:
                                                            _vm
                                                              .taxesPaymentDetails
                                                              .observation,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.taxesPaymentDetails,
                                                              "observation",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "taxesPaymentDetails.observation",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  )
                                                : _vm._e(),
                                            ],
                                            1
                                          ),
                                        ]
                                      : _vm._e(),
                                  ],
                                  2
                                )
                              : _vm._e(),
                          ],
                          1
                        )
                      : _vm._e(),
                    !_vm.isBulkPay &&
                    !_vm.isPaymentConfirmation &&
                    _vm.selectedCheckingAccount &&
                    _vm.selectedCheckingAccount.workspaceId &&
                    _vm.installmentPayForm.payOnInternetBanking &&
                    (_vm.installmentPayForm.paymentMethod.method ===
                      _vm.paymentTypeEnum.PIX ||
                      _vm.installmentPayForm.paymentMethod.method ===
                        _vm.paymentTypeEnum.STORE_CREDIT)
                      ? _c(
                          "b-row",
                          [
                            _c(
                              "b-col",
                              { attrs: { md: "12" } },
                              [
                                _c("FormulateInput", {
                                  staticClass: "required",
                                  attrs: {
                                    type: "radio",
                                    options:
                                      _vm.internetBankingPixPaymentTypes(),
                                    label: _vm.$t("Tipo de chave PIX"),
                                    "element-class": ["d-flex", "mt-1"],
                                    validation: "required",
                                  },
                                  model: {
                                    value:
                                      _vm.installmentPayForm
                                        .internetBankingPixType,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.installmentPayForm,
                                        "internetBankingPixType",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "installmentPayForm.internetBankingPixType",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              "b-col",
                              [
                                _vm.installmentPayForm
                                  .internetBankingPixType !== "AGENCIA_CONTA"
                                  ? _c("FormulateInput", {
                                      attrs: {
                                        type: "text",
                                        label: _vm.$t("Chave PIX"),
                                      },
                                      model: {
                                        value: _vm.installmentPayForm.pixCode,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.installmentPayForm,
                                            "pixCode",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "installmentPayForm.pixCode",
                                      },
                                    })
                                  : _c(
                                      "b-row",
                                      [
                                        _c(
                                          "b-col",
                                          { attrs: { md: "4" } },
                                          [
                                            _c("FormulateInput", {
                                              staticClass: "required",
                                              attrs: {
                                                type: "text",
                                                label:
                                                  _vm.$t("Código do banco"),
                                                validation: "required",
                                              },
                                              model: {
                                                value:
                                                  _vm.installmentPayForm
                                                    .pixBankAccountBankCode,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.installmentPayForm,
                                                    "pixBankAccountBankCode",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "installmentPayForm.pixBankAccountBankCode",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "b-col",
                                          { attrs: { md: "4" } },
                                          [
                                            _c("FormulateInput", {
                                              staticClass: "required",
                                              attrs: {
                                                type: "text",
                                                label: _vm.$t("Agência"),
                                                validation: "required",
                                              },
                                              model: {
                                                value:
                                                  _vm.installmentPayForm
                                                    .pixBankAccountBranch,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.installmentPayForm,
                                                    "pixBankAccountBranch",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "installmentPayForm.pixBankAccountBranch",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "b-col",
                                          { attrs: { md: "4" } },
                                          [
                                            _c("FormulateInput", {
                                              staticClass: "required",
                                              attrs: {
                                                type: "text",
                                                label: _vm.$t("Conta"),
                                                validation: "required",
                                              },
                                              model: {
                                                value:
                                                  _vm.installmentPayForm
                                                    .pixBankAccountAccountNumber,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.installmentPayForm,
                                                    "pixBankAccountAccountNumber",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "installmentPayForm.pixBankAccountAccountNumber",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "b-col",
                                          { attrs: { md: "4" } },
                                          [
                                            _c("FormulateInput", {
                                              staticClass: "required",
                                              attrs: {
                                                type: "select",
                                                label: _vm.$t("Tipo de conta"),
                                                validation: "required",
                                                options: [
                                                  {
                                                    value: "CONTA_CORRENTE",
                                                    label:
                                                      _vm.$t("Conta Corrente"),
                                                  },
                                                  {
                                                    value: "CONTA_POUPANCA",
                                                    label:
                                                      _vm.$t("Conta Poupança"),
                                                  },
                                                  {
                                                    value: "CONTA_PAGAMENTO",
                                                    label:
                                                      _vm.$t("Conta Pagamento"),
                                                  },
                                                ],
                                              },
                                              model: {
                                                value:
                                                  _vm.installmentPayForm
                                                    .pixBankAccountAccountType,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.installmentPayForm,
                                                    "pixBankAccountAccountType",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "installmentPayForm.pixBankAccountAccountType",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "b-col",
                                          { attrs: { md: "4" } },
                                          [
                                            _c("FormulateInput", {
                                              staticClass: "required",
                                              attrs: {
                                                type: "select",
                                                label:
                                                  _vm.$t("Tipo de documento"),
                                                validation: "required",
                                                options: [
                                                  {
                                                    value: "CPF",
                                                    label: _vm.$t("CPF"),
                                                  },
                                                  {
                                                    value: "CNPJ",
                                                    label: _vm.$t("CNPJ"),
                                                  },
                                                ],
                                              },
                                              model: {
                                                value:
                                                  _vm.installmentPayForm
                                                    .pixBankAccountDocumentType,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.installmentPayForm,
                                                    "pixBankAccountDocumentType",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "installmentPayForm.pixBankAccountDocumentType",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "b-col",
                                          { attrs: { md: "4" } },
                                          [
                                            _c("FormulateInput", {
                                              staticClass: "required",
                                              attrs: {
                                                type: "text",
                                                label: _vm.$t(
                                                  "Número do documento"
                                                ),
                                                validation: "required",
                                              },
                                              model: {
                                                value:
                                                  _vm.installmentPayForm
                                                    .pixBankAccountDocumentNumber,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.installmentPayForm,
                                                    "pixBankAccountDocumentNumber",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "installmentPayForm.pixBankAccountDocumentNumber",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                              ],
                              1
                            ),
                            _c(
                              "b-col",
                              { attrs: { md: "12" } },
                              [
                                _c("FormulateInput", {
                                  attrs: {
                                    type: "switch",
                                    label: _vm.$t(
                                      "Permite pagamento a terceiro?"
                                    ),
                                    instruction: _vm.$t(
                                      "Quando selecionado, o sistema permitirá que o pagamento seja feito para uma pessoa diferente do que está cadastrado na despesa."
                                    ),
                                  },
                                  model: {
                                    value:
                                      _vm.installmentPayForm.canPayToThirdParty,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.installmentPayForm,
                                        "canPayToThirdParty",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "installmentPayForm.canPayToThirdParty",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.isBulkPay && !_vm.isPaymentConfirmation
                      ? _c(
                          "b-row",
                          [
                            _c(
                              "b-col",
                              [
                                _c("FormulateInput", {
                                  attrs: {
                                    id: "modal_pay_installment-group_items",
                                    type: "switch",
                                    label: _vm.$t("Agrupar baixas?"),
                                    instructions: [
                                      {
                                        text: _vm.$t(
                                          "Serão criados lançamentos na conta corrente agrupados por Forma de Pagamento e Bandeira do Cartão (quando aplicável), com o valor da soma das parcelas agrupadas"
                                        ),
                                      },
                                      {
                                        text: _vm.$t(
                                          "O estorno de uma parcela baixada em grupo implicará no estorno de todas as parcelas que foram baixadas juntas"
                                        ),
                                      },
                                    ],
                                  },
                                  model: {
                                    value: _vm.groupItems,
                                    callback: function ($$v) {
                                      _vm.groupItems = $$v
                                    },
                                    expression: "groupItems",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.isBulkPay || _vm.isPaymentConfirmation
                      ? _c(
                          "b-row",
                          [
                            _c(
                              "b-col",
                              [
                                _vm.selectedCheckingAccount
                                  ? _c("FormulateInput", {
                                      attrs: {
                                        value: _vm.selectedCheckingAccount.name,
                                        type: "label",
                                        label: _vm.$t("Conta Corrente"),
                                      },
                                    })
                                  : _vm._e(),
                                _c("b-table", {
                                  staticClass: "bordered",
                                  attrs: {
                                    "show-empty": "",
                                    responsive: "",
                                    fields: _vm.fields,
                                    items: _vm.installmentBulkPay,
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "cell(discount)",
                                        fn: function (row) {
                                          return [
                                            _c("FormulateInput", {
                                              attrs: {
                                                id:
                                                  "modal_bulk_pay_installment-discount-" +
                                                  row.index,
                                                type: "text-number",
                                                currency: "R$",
                                                precision: 2,
                                              },
                                              on: {
                                                blur: function (value) {
                                                  return _vm.onInputDiscount(
                                                    value,
                                                    row.item
                                                  )
                                                },
                                              },
                                              model: {
                                                value: row.item.discount,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    row.item,
                                                    "discount",
                                                    $$v
                                                  )
                                                },
                                                expression: "row.item.discount",
                                              },
                                            }),
                                          ]
                                        },
                                      },
                                      {
                                        key: "cell(interest)",
                                        fn: function (row) {
                                          return [
                                            _c("FormulateInput", {
                                              attrs: {
                                                id:
                                                  "modal_bulk_pay_installment-interest-" +
                                                  row.index,
                                                type: "text-number",
                                                currency: "R$",
                                                precision: 2,
                                              },
                                              on: {
                                                blur: function (value) {
                                                  return _vm.onInputInterest(
                                                    value,
                                                    row.item
                                                  )
                                                },
                                              },
                                              model: {
                                                value: row.item.interest,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    row.item,
                                                    "interest",
                                                    $$v
                                                  )
                                                },
                                                expression: "row.item.interest",
                                              },
                                            }),
                                          ]
                                        },
                                      },
                                      {
                                        key: "cell(paymentValue)",
                                        fn: function (row) {
                                          return [
                                            _c("FormulateInput", {
                                              attrs: {
                                                id:
                                                  "modal_bulk_pay_installment-payment_value-" +
                                                  row.index,
                                                value:
                                                  row.item.value +
                                                  (row.item.interest || 0) -
                                                  (row.item.discount || 0),
                                                type: "label",
                                                filter: "currency",
                                                precision: 2,
                                              },
                                            }),
                                          ]
                                        },
                                      },
                                      {
                                        key: "cell(action)",
                                        fn: function (row) {
                                          return [
                                            _c("e-grid-actions", {
                                              attrs: {
                                                "show-update": false,
                                                "show-delete": true,
                                              },
                                              on: {
                                                update: function () {},
                                                delete: function ($event) {
                                                  return _vm.onRemoveInstallment(
                                                    row.item
                                                  )
                                                },
                                              },
                                            }),
                                          ]
                                        },
                                      },
                                      {
                                        key: "custom-foot",
                                        fn: function () {
                                          return [
                                            _c("tr", [
                                              _c(
                                                "th",
                                                {
                                                  staticClass: "text-right",
                                                  attrs: {
                                                    colspan:
                                                      _vm.isPaymentConfirmation
                                                        ? 7
                                                        : 5,
                                                  },
                                                },
                                                [_vm._v(" Total ")]
                                              ),
                                              _c(
                                                "th",
                                                { staticClass: "text-right" },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm._f("currency")(
                                                          _vm.getTotalInfos
                                                            .totalInstallmentsValue
                                                        )
                                                      ) +
                                                      " "
                                                  ),
                                                ]
                                              ),
                                              !_vm.isPaymentConfirmation
                                                ? _c(
                                                    "th",
                                                    {
                                                      staticClass: "text-right",
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm._f("currency")(
                                                              _vm.getTotalInfos
                                                                .totalDiscountValue
                                                            )
                                                          ) +
                                                          " "
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                              _c(
                                                "th",
                                                { staticClass: "text-right" },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm._f("currency")(
                                                          _vm.getTotalInfos
                                                            .totalInterestValue
                                                        )
                                                      ) +
                                                      " "
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "th",
                                                { staticClass: "text-right" },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm._f("currency")(
                                                          _vm.getTotalInfos
                                                            .totalPaymentValue
                                                        )
                                                      ) +
                                                      " "
                                                  ),
                                                ]
                                              ),
                                            ]),
                                          ]
                                        },
                                        proxy: true,
                                      },
                                    ],
                                    null,
                                    false,
                                    626547019
                                  ),
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        )
                      : _c("b-row"),
                  ],
                  1
                ),
              ],
              1
            ),
          ]
        },
        proxy: true,
      },
      {
        key: "sidebar-footer",
        fn: function () {
          return [
            _c("e-button", {
              staticClass: "mr-1",
              attrs: {
                id: "modal_pay_installment-btn_cancel",
                variant: "outline-primary",
                text: _vm.$t("Cancelar"),
                "text-shortcuts": ["ESC"],
              },
              on: { click: _vm.hideModal },
            }),
            _c("e-button", {
              attrs: {
                id: "modal_pay_installment-btn_confirm",
                variant: "primary",
                icon: "cash",
                text: _vm.$t("Confirmar baixa"),
                busy: _vm.saving,
              },
              on: { click: _vm.onConfirm },
            }),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }